import {useSelector} from 'react-redux';
import Selector from '../../selectors/modals_action';

import Invite from './invite';
import Telegram from './telegram';
import MobileApp from './mobile-app';
import Notifications from './notifications';
import FacebookFollow from './facebook-follow';
import CashappAvailable from './cashapp-available';
import ZelleAvailable from './zelle-available';
import CryptoBonus from './crypto-bonus';
import SocialAffiliate from './social-affiliate';
import TelegramPush from './telegram-push';
import WelcomePackage from './welcome-package';
import AffiliateSignup from './affiliate-signup';
import _250Years from './250y';
import NotificationsBonuses from './notifications-bonuses';

export default () => {
    const {active} = useSelector(Selector);

    return (
        <>
            {active.map((modal, key) => {
                if(modal.key === 'affiliate_signup') return <AffiliateSignup details={modal} index={key} />
                if(modal.key === 'welcome-package') return <WelcomePackage details={modal} index={key} />
                if(modal.key === 'invite') return <Invite details={modal} index={key} />
                if(modal.key === 'telegram') return <Telegram details={modal} index={key} />
                if(modal.key === 'mobile-app') return <MobileApp details={modal} index={key} />
                if(modal.key === 'notifications') return <Notifications details={modal} index={key} />
                // if(modal === 'notifications') return <TelegramPush index={key} />
                if(modal.key === 'facebook-follow') return <FacebookFollow details={modal} index={key} />
                if(modal.key === 'cashapp-available') return <CashappAvailable details={modal} index={key} />
                if(modal.key === 'zelle-available') return <ZelleAvailable details={modal} index={key} />
                if(modal.key === 'crypto-bonus') return <CryptoBonus details={modal} index={key} />
                if(modal.key === 'social-affiliate') return <SocialAffiliate details={modal} index={key} /> 
                if(modal.key === 'telegram-push') return <TelegramPush details={modal} index={key} /> 
                if(modal.key === '250-years') return <_250Years details={modal}  index={key} /> 
                if(modal.key === 'notifications-freeplay') return <NotificationsBonuses.Freeplay details={modal}  index={key} /> 
                if(modal.key === 'notifications-deposit-boost') return <NotificationsBonuses.DepositBoost details={modal}  index={key} /> 
                return <></>;
            })}
        </>
    )
}